import appGlobalScript from '/app/apps/weinfreunde/src/global/app.ts';
export const globalScripts = appGlobalScript;
